import type { Unit } from 'types/unit';

import config from 'configs/app';
import { getEnvValue } from 'configs/app/utils';

const weiName = config.chain.currency.weiName || 'wei';

export const currencyUnits: Record<Unit, string> = {
  wei: weiName,
  gwei: `G${weiName}`,
  // @ts-ignore
  ether: config.chain.currency.symbol || getEnvValue('NEXT_PUBLIC_NETWORK_NAME'),
};
